import {createFileRoute} from '@tanstack/react-router';
import {GuideExtensionPage} from '@/features/guides/pages/GuideExtensionPage';

export const Route = createFileRoute('/_app/guides/extension')({
  component: () => <GuideExtensionPage />,
});
